module.exports = __webpack_public_path__ + "static/media/3040163000_01.dc361446.jpg";